function updatePopup(upsellProduct) {
    const cartSwitcher = document.getElementById('cartswitcher');
    const cartDrawer = document.querySelector('body>cart-drawer');
    const sectionToRender = 'upsell-modal';
    const renderURL = upsellProduct + '?sections=' + sectionToRender;
    let upsellModalMarkup = '';

    fetch(renderURL)
    .then(response => response.json())
    .then(data => {
        upsellModalMarkup = data[sectionToRender];
        cartSwitcher.innerHTML = upsellModalMarkup;

        // filter colours
        let newColorListItems = document.querySelectorAll('.cartswap-modal-container .pdp--colours-list li');
        newColorListItems.forEach(function(item) {
            if (item.dataset.colours.indexOf(cartSwitcher.dataset.color) < 0) {
                item.classList.add('disabled');
            }
        });

        // preselect size (if applicable)
        let inputSizes = document.querySelectorAll('.cartswap-modal-container variant-popup-radios fieldset input[type="radio"]:not(.disabled)');
        inputSizes.forEach(function(input) {
            if (input.value == cartSwitcher.dataset.refsize) {
                input.checked = true;
            }
        });

        let VariantPopupRadios = document.querySelector('.cartswap-modal-container variant-popup-radios');
        VariantPopupRadios.onVariantChange();

        cartDrawer.close();
        setTimeout(function() {
            cartSwitcher.show();
        }, 200);
    });
}

function setSwitch(event) {

  if (event.target.closest('.button.cart-upsell')) {
    event.preventDefault();
    const cartSwitcher = document.getElementById('cartswitcher');
    const launcher = event.target.closest('.button.cart-upsell');
    cartSwitcher.dataset.refsize = launcher.dataset.refsize;
    cartSwitcher.dataset.selectors = launcher.dataset.selectors;
    cartSwitcher.dataset.color = launcher.dataset.color;
    cartSwitcher.dataset.refitem = launcher.dataset.refitem;
    cartSwitcher.dataset.linekey = launcher.dataset.linekey;

    updatePopup(launcher.href);

    return false;
  }

  if (event.target.closest('.switchcolor')) {
    event.preventDefault();
    
    updatePopup(event.target.closest('.switchcolor').href);

    return false;
  }

  if (event.target.closest('.close-upsell')) {
    const cartSwitcher = document.getElementById('cartswitcher');
    cartSwitcher.hide();
  }

  if (event.target.closest('.button.replace')) {
    event.preventDefault();
    
    if (event.target.closest('.button.replace').getAttribute('disabled') !== 'disabled') {
        // replace in cart
        const cartSwitcher = document.getElementById('cartswitcher');
        const csSubmit = document.getElementById('cssubmit');
        const cartDrawer = document.querySelector('body>cart-drawer');
        const updateURL = window.Shopify.routes.root + 'cart/update.js';

        let updates = { 'updates': {} };
        updates.updates[cartSwitcher.dataset.linekey] = 0;
        updates.updates[csSubmit.dataset.currentvar] = 1;

        if (cartDrawer) {
            //updateFormData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
            //updateFormData.append('sections_url', window.location.pathname);
            updates['sections'] = cartDrawer.getSectionsToRender().map((section) => section.id);
            updates['sections_url'] = window.location.pathname;
            cartDrawer.setActiveElement(document.activeElement);
        }


        let updateConfig = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updates)
        };

        let updateBoth = fetch(updateURL, updateConfig)
        .then((response) => response.json())
        .then((data) => {
            if (data.status) {
                alert ("an error occurred");
            }
            cartSwitcher.hide();
            cartDrawer.renderContents(data);

            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
        console.log(updateBoth);

    }

    return false;
  }

}
document.addEventListener('click', setSwitch, false);

//////////////////



class VariantPopupRadios extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        // if selected variant available, toggle button to enabled
        // else set button to disabled
        if (this.currentVariant.available) {
          this.toggleAddButton(false, '', false);
        } else {
          this.toggleAddButton(true, '', false);
        }
      }
    }
  
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateVariantInput() {
        const csSubmit = document.getElementById('cssubmit');
        if (csSubmit) {
            csSubmit.dataset.currentvar = this.currentVariant.id;
        }
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        optionInputs.forEach(input => {
          if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
            input.classList.remove('disabled');
          } else {
            input.classList.add('disabled');
          }
        });
      });
    }

  
    toggleAddButton(disable = true, text, modifyClass = true) {
        const csSubmit = document.getElementById('cssubmit');
  
        if (disable) {
            csSubmit.setAttribute('disabled', 'disabled');
        } else {
            csSubmit.removeAttribute('disabled');
        }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}`);
  
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-popup-radios', VariantPopupRadios);
  